import { Link } from "react-router-dom";
import { useState } from "react";
import Brand from "./Brand";
export default function PublicNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="public-nav">
      <div className="public-nav-inner">
        <Brand />
        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          ☰
        </button>
        <nav
          className={open ? "public-links open" : "public-links"}
          onClick={() => setOpen(false)}
        >
          <Link to="/explore">Find leads</Link>
          <Link to="/#how-it-works">How it works</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/affiliates">Affiliates</Link>
          <a href="https://meet.reachatlasleads.com" target="_blank" rel="noopener noreferrer">ReachAtlas Meet</a>
          <Link to="/help">Help</Link>
          <Link className="nav-login" to="/login">
            Sign in
          </Link>
          <Link className="button button-dark" to="/signup">
            Get started <span>↗</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
export function PublicFooter() {
  return (
    <footer className="public-footer">
      <div>
        <Brand />
        <p>A clearer path to your next customer.</p>
      </div>
      <div className="footer-nav">
        <Link to="/pricing">Pricing</Link>
        <Link to="/about">About ReachAtlas</Link>
        <Link to="/faq">FAQ</Link>
        <a href="mailto:support@reachatlasleads.com">Contact support</a>
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy</Link><Link to="/affiliates">Affiliate program</Link>
        <Link to="/opt-out">Remove my data</Link>
        <Link to="/refund">Refunds</Link>
      </div>
      <small>
        © {new Date().getFullYear()} ReachAtlas · Payments processed by Stripe
      </small>
    </footer>
  );
}
